<script setup lang="ts">
import {useRoute} from "vue-router";
import {computed, toRef} from "vue";
import {adminSideBarLinks, baseLinks, studentSideBarLinks} from "@/utils/constants/common.constants.ts";
import CommonUtils from "@/utils/CommonUtils.ts";
import {NavigationMenuItem} from "@nuxt/ui";
import {refDebounced} from "@vueuse/core";
import ObjectChecker from "@/utils/ObjectChecker.ts";
import {RouterNames} from "@/router/routerNames.ts";
import {BaseHeader} from "@/types/common.ts";

const route = useRoute();

const props = withDefaults(defineProps<BaseHeader>(), {
  text: ""
})

const item = toRef<NavigationMenuItem>({label: props.title});
const debounced = refDebounced(item,0)
const additions: NavigationMenuItem[] = [
  {
    label: "إكمال الحساب",
    to: {
      name: RouterNames.AUTH_COMPLETE_PROFILE,
    }
  }
]
const items: NavigationMenuItem[] = [...baseLinks, ...adminSideBarLinks, ...studentSideBarLinks, ...additions];

CommonUtils.onRouteChanged(() => {
  const activeItem = items.find(i => i.to?.name === route.name);
  if (!activeItem)
    return;
  item.value = activeItem;
})


const label = computed(() => {
  let firstNotEmptyObj = ObjectChecker.getFirstNotEmptyObj(props.title, item.value?.label);
  return firstNotEmptyObj
})
</script>
<template>
  <BaseWrapper class='mx-0 max-w-full bg-secondary-400 rounded-md py-4 shrink-0'>
    <div>
      <div class="flex items-center gap-2">
        <UIcon :name="debounced.icon" class="size-10 text-white" />
        <div v-text="label" class="text-white text-4xl leading-10 font-bold capitalize sm:text-5xl"/>
      </div>
      <span v-text="text" class="text-white/90 text-sm"/>
    </div>
  </BaseWrapper>
</template>
